/**
 * @file A point for all requests
 */

import axios from 'axios';
import { withParams } from '../utils/url';

const api = require('./api.json');

const getHeaders = () => ({
  headers: { 'Authorization': `Bearer ${window.localStorage.getItem('token')}`}
});

const getHeadersFile = () => ({
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'multipart/form-data',
    'Authorization': `Bearer ${window.localStorage.getItem('token')}`
  }
});

const getHeadersRandomize = () => ({
  headers: {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': process.env.REACT_APP_UI_URL,
  },
  auth: {
    username: process.env.REACT_APP_SECRET_NAME,
    password: process.env.REACT_APP_SECRET_KEY
  }
});

/**
 * Development/ production apiUrl()
 */
export const apiUrl = () => process.env.REACT_APP_API_URL;

/**
 * login request
 */
export const loginRequest = ({ username, password }) =>
  axios.post(`${apiUrl()}${api.login}`, {username, password});

/**
 * login 2 factor request
 */
export const loginTwoFactorRequest = ({ username, password, code }) =>
  axios.post(`${apiUrl()}${api.loginTwoFactor}`, {username, password, code});

/**
 * Sign out request
 */
export const logoutRequest = () =>
  axios.post(`${apiUrl()}${api.logout}`, null, getHeaders());

/**
 * Reset password request
 */
export const resetPasswordRequest = ({ username}) =>
  axios.post(`${apiUrl()}${api.resetPassword}`, {username});

/**
 * Reset password confirm user
 */
export const resetPasswordConfirmUserRequest = ({ token }) =>
  axios.get(`${apiUrl()}${withParams(api.resetPasswordConfirm, { token })}`);

/**
 * Reset password confirm user
 */
export const resetPasswordConfirmRequest = ({ token, password, confirm_password }) =>
  axios.post(`${apiUrl()}${withParams(api.resetPasswordConfirm, { token })}`, { password, confirm_password });

/**
 * Reset password in profile
 */
export const resetPasswordProfileRequest = ({ current_password, new_password, confirm_new_password }) =>
  axios.put(`${apiUrl()}${api.resetPasswordProfile}`, { current_password, new_password, confirm_new_password }, getHeaders());

/**
 * Reset password confirm user
 */
export const setPasswordConfirmRequest = ({ token, password, confirm_password }) =>
  axios.post(`${apiUrl()}${withParams(api.setPasswordConfirm, { token })}`, { password, confirm_password });

/**
 * Get setting password user
 */
export const setPasswordConfirmUserRequest = ({ token }) =>
  axios.get(`${apiUrl()}${withParams(api.setPasswordConfirm, { token })}`);


/**
 * Get Permissions
 */
export const getPermissionsRequest = () =>
  axios.get(`${apiUrl()}${api.permissions}`, getHeaders());

/**
 * Get QR
 */
export const getQRCodeRequest = () =>
  axios.get(`${apiUrl()}${api.qrCode}`, getHeaders());

/**
 * Get notificationSettings
 */
export const getNotificationSettingsRequest = () =>
  axios.get(`${apiUrl()}${api.notificationSettings}`, getHeaders());

/**
 * Set notificationSettings
 */
export const setNotificationSettingsRequest = notifications =>
  axios.put(`${apiUrl()}${api.notificationSettings}`, notifications, getHeaders());

/**
 * Get Account info
 */
export const getAccountInfoRequest = () =>
  axios.get(`${apiUrl()}${api.accountProfile}`, getHeaders());

/**
 * Update Account info
 */
export const updateAccountInfoRequest = profile =>
  axios.put(`${apiUrl()}${api.accountProfile}`, profile, getHeaders());

/**
 * Get two Factor status
 */
export const getTwoFactorRequest = () =>
  axios.get(`${apiUrl()}${api.twoFactor}`, getHeaders());

/**
 * Update two Factor status
 */
export const updateTwoFactorMethodsRequest = params =>
  axios.put(`${apiUrl()}${api.twoFactor}`, params, getHeaders());

/**
 * set two Factor status
 */
export const setTwoFactorRequest = (status) =>
  axios.put(`${apiUrl()}${withParams(api.twoFactorStatus, { status })}`, {}, getHeaders());

/**
 * Get Sites
 */
export const getSitesRequest = () =>
  axios.get(`${apiUrl()}${api.sites}`, getHeaders());

/**
 * Get followUp
 */
export const getFollowUpRequest = subjectID =>
  axios.get(`${apiUrl()}${withParams(api.followUp, { subjectID })}`, getHeaders());

/**
 * Get followUps
 */
export const getFollowUpsRequest = ({ filter_by, page, per_page, site_id }) =>
  axios.get(`${apiUrl()}${withParams(api.followups, { filter_by, page, per_page, site_id })}`, getHeaders());

/**
 * Create followUp
 */
export const createFollowUpRequest = (subjectID, followUp) =>
  axios.post(`${apiUrl()}${withParams(api.followUp, { subjectID })}`, followUp, getHeaders());

/**
 * Update followUp
 */
export const updateFollowUpRequest = (subjectID, followUp) =>
  axios.put(`${apiUrl()}${withParams(api.followUp, { subjectID })}`, followUp, getHeaders());

/**
 * Lock followUp
 */
export const lockFollowUpRequest = subjectID =>
  axios.put(`${apiUrl()}${withParams(api.followUpLock, { subjectID })}`, {}, getHeaders());

/**
 * Unlock followUp
 */
export const unlockFollowUpRequest = subjectID =>
  axios.put(`${apiUrl()}${withParams(api.followUpUnlock, { subjectID })}`, {}, getHeaders());


/**
 * Get subject
 */
export const getSubjectRequest = subjectID =>
  axios.get(`${apiUrl()}${subjectID ? withParams(api.subjectID, { subjectID }) : api.subjects}`, getHeaders());

/**
 * Delete subject
 */
export const deleteSubjectRequest = subjectID =>
  axios.delete(`${apiUrl()}${withParams(api.subjectID, { subjectID })}`, getHeaders());

/**
 * Activate subject
 */
export const activateSubjectRequest = subjectID =>
  axios.put(`${apiUrl()}${withParams(api.subjectActivate, { subjectID })}`, {}, getHeaders());

/**
 * Lock subject
 */
export const lockSubjectRequest = subjectID =>
  axios.put(`${apiUrl()}${withParams(api.subjectLock, { subjectID })}`, {}, getHeaders());

/**
 * Unlock subject
 */
export const unlockSubjectRequest = subjectID =>
  axios.put(`${apiUrl()}${withParams(api.subjectUnlock, { subjectID })}`, {}, getHeaders());

/**
 * Update subject
 */
export const updateSubjectRequest = (subjectID, profile) =>
  axios.put(`${apiUrl()}${withParams(api.subjectProfile, { subjectID })}`, profile, getHeaders());

/**
 * Create subject
 */
export const createSubjectRequest = (subjectID, profile) =>
  axios.post(`${apiUrl()}${withParams(api.subjectProfile, { subjectID })}`, profile, getHeaders());

/**
 * Create registry IDs
 */
export const createRegistryIDProfileRequest = (id, registry) =>
  axios.post(`${apiUrl()}${withParams(api.createRegistryID, { id })}`, registry, getHeaders());

/**
 * Update registry IDs
 */
export const updateRegistryIDProfileRequest = (id, registry) =>
  axios.put(`${apiUrl()}${withParams(api.updateRegistryID, { id })}`, registry, getHeaders());

/**
 * Update email status
 */
export const updateEmailStatusRequest = (id, consent_email_status) =>
  axios.put(`${apiUrl()}${withParams(api.updateEmailStatus, { id })}`, { consent_email_status }, getHeaders());


export const updateConsentGivenRequest = (id, custom_consent_given) =>
  axios.put(`${apiUrl()}${withParams(api.updateConsentGiven, { id })}`, { custom_consent_given }, getHeaders());

export const updateAdjudicatedConsentStatusRequest = (id, data) =>
  axios.put(`${apiUrl()}${withParams(api.updateAdjudicatedConsentStatus, { id })}`, data, getHeaders());

/**
 * Get Dashboard data
 */
export const getDashboardRequest = ({ filter, siteCode, start_date, end_date }) =>
  axios.get(`${apiUrl()}${withParams(api.dashboard, { filter_by: filter, site_code: siteCode, start_date, end_date } )}`, getHeaders());


/**
 * Get Saes list by filter
 */
export const getSAEsListRequest = (subjectID, siteCode) =>
  axios.get(`${apiUrl()}${withParams(api.saesList, { site_code: siteCode || undefined, subject_id: subjectID || undefined })}`, getHeaders());

/**
 * Get Sae by subjectID
 */
export const getSAERequest = subjectID =>
  axios.get(`${apiUrl()}${withParams(api.saeRecording, { subjectID })}`, getHeaders());

/**
 * Create SAE
 */
export const createSAERequest = (subjectID, sae) =>
  axios.post(`${apiUrl()}${withParams(api.saeRecording, { subjectID })}`, sae, getHeaders());

/**
 * Update SAE
 */
export const updateSAERequest = (subjectID, saeID, sae) =>
  axios.put(`${apiUrl()}${withParams(api.saeRecordingSave, { subjectID, saeID })}`, sae, getHeaders());

/**
 * Delete SAE
 */
export const deleteSAERequest = (subjectID, saeID) =>
  axios.delete(`${apiUrl()}${withParams(api.saeRecordingSave, { subjectID, saeID })}`, getHeaders());

/**
 * Lock SAE
 */
export const lockSAERequest = (subjectID, saeID) =>
  axios.put(`${apiUrl()}${withParams(api.saeLock, { subjectID, saeID })}`, {}, getHeaders());

/**
 * Unlock SAE
 */
export const unlockSAERequest = (subjectID, saeID) =>
  axios.put(`${apiUrl()}${withParams(api.saeUnlock, { subjectID, saeID })}`, {}, getHeaders());

/**
 * Delete SAE
 */
export const toggleActivateSAERequest = (subjectID, saeID, state) =>
  state === 'inactive'
    ?
    axios.put(`${apiUrl()}${withParams(api.saeRecordingActivation, { subjectID, saeID, status: 'activate' })}`, {}, getHeaders())
    :
    axios.delete(`${apiUrl()}${withParams(api.saeRecordingActivation, { subjectID, saeID, status: 'deactivate' })}`, getHeaders());


/**
 * Get patients
 */
export const getPatientsRequest = ({ page, per_page }) =>
  axios.get(`${apiUrl()}${withParams(api.subjects, { page, per_page })}`, getHeaders());

/**
 * Get documents request
 */
export const getDocumentsSearchRequest = ({ nameSearch, page, per_page, order_column, order_direction, filter_by, filter_value, filter_approve }) =>
  axios.post(`${apiUrl()}${withParams(api.documentsSearch, { name: nameSearch, page, per_page, order_column, order_direction })}`, { filter_by, filter_value, filter_approve }, getHeaders());

/**
 * Get documents training request
 */
export const getDocumentsTrainingSearchRequest = ({ nameSearch, page, per_page, order_column, order_direction, }) =>
  axios.get(`${apiUrl()}${withParams(api.documentsTraining, { name: nameSearch, page, per_page, order_column, order_direction, })}`, getHeaders());

/**
 * Get documents public request
 */
export const getDocumentsPublicSearchRequest = ({ nameSearch, page, per_page, order_column, order_direction, }) =>
  axios.get(`${apiUrl()}${withParams(api.documentsPublic, { name: nameSearch, page, per_page, order_column, order_direction, })}`, getHeaders());

/**
 * Get subject request
 */
export const getSubjectSearchRequest = ({ subjectID, filter_by, site_code, events, event_status, order_direction, page, per_page, order_column }) =>
  axios.get(`${apiUrl()}${withParams(subjectID ? api.subjectID : api.subjects, { subjectID, filter_by, site_code, events, event_status, order_direction, page, per_page, order_column })}`, getHeaders());

/**
 * Get settings sites
 */
export const getSettingsSitesRequest = ({ nameSearch, order_column, order_direction }) =>
  axios.get(`${apiUrl()}${withParams(api.settingsSites,{ search: nameSearch, order_column, order_direction })}`, getHeaders());

/**
 * Update Site
 */
export const updateSiteRequest = (siteID, site) =>
  axios.put(`${apiUrl()}${withParams(api.updateSite, { siteID })}`, site, getHeaders());

/**
 * Delete Site
 */
export const deleteSiteRequest = siteID =>
  axios.delete(`${apiUrl()}${withParams(api.updateSite, { siteID })}`, getHeaders());

/**
 * Activate Site
 */
export const activateSiteRequest = siteID =>
  axios.put(`${apiUrl()}${withParams(api.activateSite, { siteID })}`, {}, getHeaders());

/**
 * Create Site
 */
export const createSiteRequest = site =>
  axios.post(`${apiUrl()}${api.createSite}`, site, getHeaders());

/**
 * Get settings users
 */
export const getSettingsUsersRequest = ({ page, per_page, order_column, order_direction, filter_by, user_id, site_code, nameSearch }) =>
  axios.get(`${apiUrl()}${withParams(api.settingsUsers, { name: nameSearch, page, per_page, order_column, order_direction, filter_by, user_id, site_code } )}`, getHeaders());

/**
 * Get single user
 */
export const getSettingsUserSingleRequest = userID =>
  axios.get(`${apiUrl()}${withParams(api.userSingle, { userID })}`, getHeaders());

/**
 * Contact Us
 */
export const contactUsRequest = payload =>
  axios.post(`${apiUrl()}${api.contactUs}`, payload, getHeadersRandomize());

/**
 * Trial documents
 */
export const getPublicDocumentsRequest = () =>
  axios.get(`${apiUrl()}${api.publicDocuments}`, getHeadersRandomize());

/**
 * Update User
 */
export const updateUserRequest = (userID, user) =>
  axios.put(`${apiUrl()}${withParams(api.updateUser, { userID })}`, user, getHeaders());

/**
 * Delete User
 */
export const deleteUserRequest = userID =>
  axios.delete(`${apiUrl()}${withParams(api.updateUser, { userID })}`, getHeaders());

/**
 * Activate User
 */
export const activateUserRequest = userID =>
  axios.put(`${apiUrl()}${withParams(api.activateUser, { userID })}`, {}, getHeaders());

/**
 * Create User
 */
export const createUserRequest = user =>
  axios.post(`${apiUrl()}${api.createUser}`, user, getHeaders());

/**
 * Create User Training
 */
export const createUserTrainingRequest = (id, training) =>
  axios.post(`${apiUrl()}${withParams(api.createUserTraining, { id })}`, training, getHeaders());

/**
 * Create User Training Upload
 */
export const createUserTrainingUploadRequest = (id, training) =>
  axios.post(`${apiUrl()}${withParams(api.createUserTrainingUpload, { id })}`, training, getHeadersFile());

/**
 * Create User Training Upload
 */
export const resetUserTrainingRetriesRequest = (id) =>
  axios.put(`${apiUrl()}${withParams(api.resetUserTrainingRetriesRequest, { id })}`, {}, getHeadersFile());

/**
 * Get settings roles
 */
export const getSettingsRolesRequest = () =>
  axios.get(`${apiUrl()}${api.settingsRoles}`, getHeaders());

/**
 * Update Role
 */
export const updateRoleRequest = (roleID, role) =>
  axios.put(`${apiUrl()}${withParams(api.updateRole, { roleID })}`, role, getHeaders());

/**
 * Create Role
 */
export const createRoleRequest = role =>
  axios.post(`${apiUrl()}${api.createRole}`, role, getHeaders());

/**
 * Toggle Role activation
 */
export const toggleActivateRoleRequest = (roleID, state) =>
  state === 'inactive'
    ?
    axios.put(`${apiUrl()}${withParams(api.activateRole, { roleID })}`, {}, getHeaders())
    :
    axios.delete(`${apiUrl()}${withParams(api.updateRole, { roleID })}`, getHeaders());

/**
 * Toggle User Role activation
 */
export const toggleUserActivateRoleRequest = (userID, roleID, state) =>
  state === 'inactive'
    ?
    axios.put(`${apiUrl()}${withParams(api.userRoleSiteActivate, { userID, roleID })}`, {}, getHeaders())
    :
    axios.delete(`${apiUrl()}${withParams(api.userRoleSiteDeactivate, { userID, roleID })}`, getHeaders());

/**
 * Create user role
 */
export const createUserRoleRequest = (userID, data) => {
  return axios.post(`${apiUrl()}${withParams(api.userRoleCreate, { userID })}`, data, getHeaders());
}

/**
 * Update user role
 */
export const updateUserRoleRequest = (userID, siteID, data) => {
  return axios.put(`${apiUrl()}${withParams(api.userRoleUpdate, { userID, siteID })}`, data, getHeaders());
}

/**
 * Create Document
 */
export const createDocumentRequest = document => {
  return axios.post(`${apiUrl()}${api.documents}`, document, getHeaders());
}

/**
 * Create Patient Profile Document
 */
export const createPatientProfileDocumentRequest = document => {
  return axios.post(`${apiUrl()}${api.patientProfileDocuments}`, document, getHeaders());
}

/**
 * Update Document
 */
export const updateDocumentRequest = (documentID, document) =>
  axios.put(`${apiUrl()}${withParams(api.updateDocument, { documentID })}`, document, getHeadersFile());

/**
 * Update Patient Profile Document
 */
export const updatePatientProfileDocumentRequest = (documentID, document) =>
  axios.put(`${apiUrl()}${withParams(api.updatePatientProfileDocument, { documentID })}`, document, getHeadersFile());

/**
 * Delete Patient Profile Document
 */
export const deletePatientProfileDocumentRequest = (documentID) =>
  axios.delete(`${apiUrl()}${withParams(api.deletePatientProfileDocument, { documentID })}`, getHeaders());

/**
 * Delete Document
 */
export const deleteDocumentRequest = documentID =>
  axios.delete(`${apiUrl()}${withParams(api.updateDocument, { documentID })}`, getHeaders());

/**
 * Activate Document
 */
export const activateDocumentRequest = documentID =>
  axios.put(`${apiUrl()}${withParams(api.activateDocument, { documentID })}`, {}, getHeaders());

/**
 * Activate Patient Profile Document
 */
export const activatePatientProfileDocumentRequest = documentID =>
  axios.put(`${apiUrl()}${withParams(api.activatePatientProfileDocument, { documentID })}`, {}, getHeaders());

/**
 * Approve Document
 */
export const approveDocumentRequest = documentID =>
  axios.put(`${apiUrl()}${withParams(api.approveDocument, { documentID })}`, {}, getHeaders());

/**
 * Unapprove Document
 */
export const unapproveDocumentRequest = documentID =>
  axios.put(`${apiUrl()}${withParams(api.unapproveDocument, { documentID })}`, {}, getHeaders());



/**
 * Create Consent
 */
export const getConsentRequest = ({nameSearch, stateFilter}) => {
  let params = {};
  if (nameSearch){
    params['search'] = nameSearch;
  }
  if (stateFilter){
    params['state'] = stateFilter;
  }
 return axios.get(`${apiUrl()}${withParams(api.settingsConsent, params)}`, getHeaders());
}

/**
 * Create Consent
 */
export const createConsentRequest = consent =>
  axios.post(`${apiUrl()}${api.settingsConsent}`, consent, getHeaders());

/**
 * Update Consent
 */
export const updateConsentRequest = (consentID, consent) =>
  axios.put(`${apiUrl()}${withParams(api.settingsConsentUpdate, { consentID })}`, consent, getHeaders());

/**
 * Delete Consent
 */
export const deleteConsentRequest = consentID =>
  axios.delete(`${apiUrl()}${withParams(api.settingsConsentUpdate, { consentID })}`, getHeaders());

/**
 * Activate Consent
 */
export const activateConsentRequest = consentID =>
  axios.put(`${apiUrl()}${withParams(api.settingsConsentActivate, { consentID })}`, {}, getHeaders());

/**
 * Get settings general
 */
export const getSettingsGeneralRequest = () => {
  return axios.get(`${apiUrl()}${api.settingsGeneral}`, getHeaders());
}

/**
 * Create settings
 */
export const createSettingsGeneralRequest = data => {
  return axios.post(`${apiUrl()}${api.settingsGeneral}`, data, getHeaders());
}

/**
 * Update settings
 */
export const updateSettingsGeneralRequest = (id, data) => {
  return axios.put(`${apiUrl()}${withParams(api.settingsGeneralUpdate, { id })}`, data, getHeaders());
}

/**
 * Delete setting
 */
export const deleteSettingsGeneralRequest = (id) => {
  return axios.delete(`${apiUrl()}${withParams(api.settingsGeneralUpdate, { id })}`, getHeaders());
}

/**
 * Activate setting
 */
export const activateSettingsGeneralRequest = (id) => {
  return axios.put(`${apiUrl()}${withParams(api.settingsGeneralActivate, { id })}`, {}, getHeaders());
}

/**
 * Get audit logs
 */
export const getAuditLogsRequest = ({ nameSearch, page, per_page, order_column, order_direction, filter_by, filter_value, filter_approve }) => {
  return axios.post(`${apiUrl()}${withParams(api.auditLogsList, { name: nameSearch, page, per_page, order_column, order_direction })}`, { filter_by, filter_value, filter_approve }, getHeaders());
}

/**
 * Update audit logs
 */
export const updateAuditLogsRequest = (id, data) => {
  return axios.put(`${apiUrl()}${withParams(api.auditLogUpdate, { id })}`, data, getHeaders());
}

/**
 * Activate audit logs
 */
export const activateAuditLogsRequest = id => {
  return axios.put(`${apiUrl()}${withParams(api.auditLogActivate, { id })}`, {}, getHeaders());
}

/**
 * Delete audit logs
 */
export const deleteAuditLogsRequest = id => {
  return axios.delete(`${apiUrl()}${withParams(api.auditLogUpdate, { id })}`, getHeaders());
}

/**
 * Resend email for audit logs
 */
export const resendAuditLogsRequest = id => {
  return axios.put(`${apiUrl()}${withParams(api.auditLogResend, { id })}`, {}, getHeaders());
}

/**
 * Reviewed audit logs
 */
export const reviewedAuditLogsRequest = id => {
  return axios.put(`${apiUrl()}${withParams(api.auditLogReviewed, { id })}`, {}, getHeaders());
}

/**
 * Unreviewed audit logs
 */
export const unreviewedAuditLogsRequest = id => {
  return axios.put(`${apiUrl()}${withParams(api.auditLogUnreviewed, { id })}`, {}, getHeaders());
}

/**
 * Get simulation sites
 */
export const getSimulationRequest = () =>
  axios.get(`${apiUrl()}${api.simulationList}`, getHeaders());

/**
 * Create simulation
 */
export const createSimulationRequest = (simulation) =>
  axios.post(`${apiUrl()}${api.createSimulation}`, simulation, getHeaders());

/**
 * Update simulation
 */
export const updateSimulationRequest = (ID, simulation) =>
  axios.put(`${apiUrl()}${withParams(api.updateSimulation, { ID })}`, simulation, getHeaders());

/**
 * Delete simulation
 */
export const deleteSimulationRequest = ID =>
  axios.delete(`${apiUrl()}${withParams(api.updateSimulation, { ID })}`, getHeaders());

/**
 * Activate Site
 */
export const activateSimulationRequest = ID =>
  axios.put(`${apiUrl()}${withParams(api.activateSimulation, { ID })}`, {}, getHeaders());

/**
 * Get training
 */
export const trainingGetRequest = _ =>
  axios.get(`${apiUrl()}${api.trainingGet}`, getHeaders());

/**
 * Training start
 */
export const trainingStartRequest = _ =>
  axios.post(`${apiUrl()}${api.trainingStart}`, {}, getHeaders());

/**
 * Training check
 */
export const trainingCheckRequest = ({ token, q_id, q_ans }) =>
  axios.post(`${apiUrl()}${withParams(api.trainingVerify, { token })}`, { q_id, q_ans }, getHeaders());


/**
 * Get newsletter request
 */
export const getNewsletterRequest = ({ search, page, per_page, order_column, order_direction }) =>
  axios.get(`${apiUrl()}${withParams(api.newsletterList, { search, page, per_page, order_column, order_direction })}`, getHeaders());


/**
 * Create Newsletter
 */
export const createNewsletterRequest = newsletter => {
  return axios.post(`${apiUrl()}${api.newsletter}`, newsletter, getHeaders());
}

/**
 * Update Newsletter
 */
export const updateNewsletterRequest = (id, newsletter) =>
  axios.put(`${apiUrl()}${withParams(api.newsletterByID, { id })}`, newsletter, getHeadersFile());


/**
 * Delete Newsletter
 */
export const deleteNewsletterRequest = id =>
  axios.delete(`${apiUrl()}${withParams(api.newsletterByID, { id })}`, getHeadersFile());

/**
 * Activate Newsletter
 */
export const activateNewsletterRequest = id =>
  axios.put(`${apiUrl()}${withParams(api.newsletterActivateByID, { id })}`, {}, getHeadersFile());

/**
 * Send Newsletter
 */
export const sendNewsletterRequest = id =>
  axios.put(`${apiUrl()}${withParams(api.newsletterSendByID, { id })}`, {}, getHeadersFile());

/**
 * Upload Newsletter Image
 */
export const uploadNewsletterImage = data =>
  axios.post(`${apiUrl()}${api.newsletterUploadImage}`, data, getHeadersFile());

/**
 * Activate Site Randomization
 */
export const activateSiteRandomizationRequest = siteID =>
  axios.put(`${apiUrl()}${withParams(api.updateSiteRandomization, { siteID })}`, {}, getHeaders());

/**
 * Delete Site Randomization
 */
export const deleteSiteRandomizationRequest = siteID =>
  axios.delete(`${apiUrl()}${withParams(api.updateSiteRandomization, { siteID })}`, getHeaders());



/**
 * get Roles minimal
 */
export const getRolesLight = () =>
  axios.get(`${apiUrl()}${api.rolesLight}`, getHeaders());

/**
 * get Users minimal
 */
export const getUsersLight = () =>
  axios.get(`${apiUrl()}${api.usersLight}`, getHeaders());

/**
 * get Bulk Site Roles
 */
export const getUserSites = id =>
  axios.get(`${apiUrl()}${withParams(api.bulkUserSites, { id })}`, getHeaders());

/**
 * copy Bulk User Permissions
 */
export const copyBulkUserPermissions = data =>
  axios.put(`${apiUrl()}${api.bulkUserCopyPermission}`, data, getHeaders());

/**
 * get Bulk Sites
 */
export const getBulkSites = () =>
  axios.get(`${apiUrl()}${api.bulkSites}`, getHeaders());

/**
 * get Bulk Site Roles
 */
export const getBulkSiteRoles = id =>
  axios.get(`${apiUrl()}${withParams(api.bulkSiteRoles, { id })}`, getHeaders());

/**
 * copy Bulk Site Permissions
 */
export const copyBulkSitePermissions = data =>
  axios.put(`${apiUrl()}${api.bulkSiteCopyPermission}`, data, getHeaders());


export const copyBulkSiteChangePermissions = data =>
  axios.put(`${apiUrl()}${api.bulkUserChangePermission}`, data, getHeaders());

/**
 * Reporting get
 */
export const getFileReporting = (type, format) =>
  axios.get(`${apiUrl()}/admin/reports/${type}?format=${format}`, getHeaders());

/**
 * Reporting by depot
 */
export const getFileReportingByDepot = (type, format) =>
  axios.get(`${apiUrl()}/admin/reports/drug_by_depot?format=${format}`, getHeaders());

export const getAccountProfileId = (password) =>
  axios.post(`${apiUrl()}${api.accountProfileId}`, { password }, getHeaders());

export const getPrivateFileLinkRequest = ({ url }) =>
  axios.post(`${apiUrl()}${withParams(api.privateDocument)}`, { url }, getHeaders());

export const createCoenrollmentProfileRequest = (id, data) =>
  axios.post(`${apiUrl()}${withParams(api.createCoenrollmentID, { id })}`, data, getHeaders());

export const updateCoenrollmentProfileRequest = (id, data) =>
  axios.put(`${apiUrl()}${withParams(api.updateCoenrollmentID, { id })}`, data, getHeaders());



// WEBPACK FOOTER //
// ./src/api/requests.js